import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";
import { Profile } from "../../../@types/profile";

// Mismo criterio que apigs (política canChangeUserEmail): privilegio "RRHH".
export const CHANGE_USER_EMAIL_PRIVILEGE = "RRHH";

export const selectCanChangeUserEmail = createSelector(
  [(store: RootState) => store.userAuthentication.user],
  (user) =>
    !!user?.profiles?.some((profile: Profile) =>
      (profile.privileges || []).includes(CHANGE_USER_EMAIL_PRIVILEGE)
    )
);
